import React from 'react';

import { BigTextHeaderData } from './bigTextHeader.types';
import { Container, Header, InnerContainer, HalfBox } from './bigTextHeader.styled';

export const BigTextHeader: React.FC<BigTextHeaderData> = (data: BigTextHeaderData) => {
  const { content, backgroundColor } = data;

  return (
    <Container backgroundColor={backgroundColor}>
      <InnerContainer>
        <Header>{content}</Header>
      </InnerContainer>
      <HalfBox />
    </Container>
  );
}
